import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    codeText: {
      ...CommonFonts.darkBoldFont24,
    },
    tooltipText: {
      ...CommonFonts.darkBoldFont14,
    },
  })
);

export default useStyles;
